import { render, staticRenderFns } from "./AzconCalendarCardSkeleton.vue?vue&type=template&id=65458425&scoped=true"
import script from "./AzconCalendarCardSkeleton.vue?vue&type=script&lang=js"
export * from "./AzconCalendarCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AzconCalendarCardSkeleton.vue?vue&type=style&index=0&id=65458425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65458425",
  null
  
)

export default component.exports